import React from 'react';
import { Card, Descriptions, Tag, Spin, Button, Space } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { useCustomerDetail } from '../../hooks/useCustomers';

const CustomerDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { customer, loading } = useCustomerDetail(id || '');

  if (loading) return <Spin size="large" style={{ display: 'block', margin: '40px auto' }} />;
  if (!customer) return <Card>Không tìm thấy khách hàng.</Card>;

  return (
    <Space direction="vertical" size={16} style={{ width: '100%' }}>
      <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/customers')}>Quay lại</Button>
      <Card title={`Khách hàng · ${customer.name || '(không tên)'}`}>
        <Descriptions column={2} bordered size="small">
          <Descriptions.Item label="Họ tên">{customer.name || '—'}</Descriptions.Item>
          <Descriptions.Item label="Email">{customer.email || '—'}</Descriptions.Item>
          <Descriptions.Item label="SĐT">{customer.phone || '—'}</Descriptions.Item>
          <Descriptions.Item label="Nguồn">{customer.source || '—'}</Descriptions.Item>
          <Descriptions.Item label="Trạng thái">
            <Tag color={customer.state === 1 ? 'success' : 'default'}>
              {customer.state === 1 ? 'Active' : 'Inactive'}
            </Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Tenant ID"><code>{customer.tenant_id || '—'}</code></Descriptions.Item>
          <Descriptions.Item label="Ngày tạo">
            {customer.created_at ? dayjs(customer.created_at).format('DD/MM/YYYY HH:mm') : '—'}
          </Descriptions.Item>
          <Descriptions.Item label="Cập nhật">
            {customer.updated_at ? dayjs(customer.updated_at).format('DD/MM/YYYY HH:mm') : '—'}
          </Descriptions.Item>
        </Descriptions>
      </Card>
    </Space>
  );
};

export default CustomerDetail;
export { CustomerDetail };
